<template>
  <div class="product-swiper" style="position:relative;">
    <div class="swiper-button-next"></div>
    <div class="swiper-container image-swiper-big">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in productImageList"
          :key="index"
        >
          <img :src="item"/>
        </div>
      </div>
    </div>
    <div
      style="--swiper-navigation-color: #fff; --swiper-pagination-color: #fff"
      thumbsSlider=""
      class="swiper-container image-swiper-small"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in productMicroImageList"
          :key="index"

          @mouseover="mouseOverImage(index)"
        >
          <img :src="item" style="width:24px; height:24px;" />
        </div>
      </div>
    </div>
    <div class="swiper-button-prev"></div>
  </div>
</template>

<script lang="ts">

import { defineComponent, type PropType } from 'vue'

import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.min.css'

export default defineComponent({
  name: 'ProductImageSwiper',
  components: { },
  props: {
    productImageList: { type: Array as PropType<Array<string>>, default: [] as Array<string> },
    productMicroImageList: { type: Array as PropType<Array<string>>, default: [] as Array<string> },
    imageSwiperBig: { type: Object as PropType<Swiper>, default: {} as Swiper }
  },
  methods: {
    mouseOverImage (index: number) {
      this.imageSwiperBig.slideTo(index)
    }
  }
})
</script>

<style scoped>
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  height: 100%;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-container {
  width: 100%;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
}

.image-swiper-big {
  width: 100%;
  height: 100%;
}

.image-swiper-small {
  height: 20%;
  box-sizing: border-box;
  padding: 10px 0;
}

.image-swiper-small .swiper-slide {
  width: 20%;
  height: 100%;
  opacity: 0.4;
}

.image-swiper-small .swiper-slide-thumb-active {
  opacity: 1;
}

.product-swiper :deep(.swiper-button-prev),
.product-swiper :deep(.swiper-button-next ) {
  position: absolute;
  top: 91.5%;
  width: calc(var(--swiper-navigation-size) / 44 * 27);
  height: var(--swiper-navigation-size);
  margin-top: calc(0px - (var(--swiper-navigation-size) / 2));
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f60;
}

.product-swiper :deep(.swiper-button-prev.swiper-button-disabled),
.product-swiper :deep(.swiper-button-next.swiper-button-disabled) {
  opacity: 0.35;
  cursor: auto;
  pointer-events: none;
  color:gray;
}

.product-swiper :deep(.swiper-button-prev:after),
.product-swiper :deep(.swiper-button-next:after) {
  font-family: swiper-icons;
  font-size: var(--swiper-navigation-size);
  text-transform: none !important;
  letter-spacing: 0;
  text-transform: none;
  font-variant: initial;
  line-height: 1;
  font-size: 18px;
  font-weight: 900;
}

.product-swiper :deep(.swiper-button-prev),
.product-swiper :deep(.swiper-container-rtl .swiper-button-next) {
  left: -20px;
  right: auto;
}

.product-swiper :deep(.swiper-button-prev:after),
.product-swiper :deep(.swiper-container-rtl .swiper-button-next:after ) {
  content: 'prev';
}

.product-swiper :deep(.swiper-button-next),
.product-swiper :deep(.swiper-container-rtl .swiper-button-prev) {
  right: -20px;
  left: auto;
}

.product-swiper :deep(.swiper-button-next:after),
.product-swiper :deep(.swiper-container-rtl .swiper-button-prev:after) {
  content: 'next';
}

@media(min-width:768px) {
    .product-swiper {
        margin-left: 13px;
    }
}
</style>
